'use client';

import { spacing } from '@/theme/partials/spacing.css';
import { Dialog } from '@mui/material';
import IconButton from '../IconButton';
import Box from '../ui/Box';
import Txt from '../ui/Txt';
import { useAcknowledgement } from './useAcknowledgement';

type AcknowledgementProps = {
  heading?: string | null;
  description?: string | null;
};

const AcknowledgementInner = ({ heading, description }: AcknowledgementProps) => {
  const { value, toggle } = useAcknowledgement();

  const isSet = value !== null;

  if (isSet) return null;

  const handleClose = () => {
    toggle(false);
  };

  return (
    <Dialog open={!isSet} onClose={handleClose}>
      <Box cx={{ position: 'relative', p: 'lg' }}>
        <IconButton
          icon="close"
          onClick={handleClose}
          style={{ position: 'absolute', top: spacing[8], right: spacing[8] }}
        />
        <Txt variant="h4" color="black">
          {heading}
        </Txt>
        <Txt html>{description}</Txt>
      </Box>
    </Dialog>
  );
};

export default AcknowledgementInner;
